import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Field, fieldPropTypes } from 'redux-form';
import { omit, pick } from 'lodash/fp';
import { compose, getContext, withProps } from 'recompose';
import Error from '../../Error';
import FieldInfo from '../FieldInfo';
import withScroll from '../withScroll';
import { withDisableField } from './TypedDisabled';

const inputProps = ['placeholder'];

const PhoneInputField = ({
    formGroup: Group,
    input: { name, value, ...input },
    info,
    meta,
    required,
    ...props
}) => (
    <Group component="label" htmlFor={name} {...omit(inputProps, props)} required={required}>
        <PhoneInput
            id={name}
            className={classNames({ filled: value || 0 === value })}
            name={name}
            country="fr"
            value={value}
            required={required}
            type="text"
            {...pick(inputProps, props)}
            {...input}
        />
        {info ? <FieldInfo id={name}>{info}</FieldInfo> : null}
        <span className="validation-feedback" />
        <Error {...meta} />
    </Group>
);

PhoneInputField.propTypes = {
    ...fieldPropTypes,
    formGroup: PropTypes.func.isRequired,
    input: PropTypes.shape({}).isRequired,
    meta: PropTypes.shape({}).isRequired,
    required: PropTypes.bool,
};

PhoneInputField.defaultProps = {
    required: false,
};

export default compose(
    withDisableField(),
    withProps({ component: PhoneInputField }),
    getContext({ formGroup: PropTypes.func.isRequired }),
    withScroll,
)(Field);
